import React, { createContext, useContext, useState } from 'react';
import { MuiKeyboard } from '../components';
var MuiKeyboardContext = createContext(undefined);
export var MuiKeyboardProvider = function (_a) {
    var children = _a.children, textField = _a.textField, _b = _a.slide, slide = _b === void 0 ? true : _b, _c = _a.direction, direction = _c === void 0 ? 'up' : _c, numbers = _a.numbers, firstLanguage = _a.firstLanguage, secondLanguage = _a.secondLanguage, secondLangLabel = _a.secondLangLabel, firstLangLabel = _a.firstLangLabel, keyboardWidth = _a.keyboardWidth, buttonSize = _a.buttonSize, labelLangButton = _a.labelLangButton, reverseButton = _a.reverseButton, singlyBack = _a.singlyBack, labelLetterButton = _a.labelLetterButton, betweenButtons = _a.betweenButtons, numbersColumns = _a.numbersColumns, numbersRows = _a.numbersRows, allKeyboardStyle = _a.allKeyboardStyle, timeout = _a.timeout;
    var _d = useState(''), inputValue = _d[0], setInputValue = _d[1];
    var _e = useState(false), checked = _e[0], setChecked = _e[1];
    var keyboardFeature = function (options) {
        if (options === void 0) { options = {}; }
        var resetText = options.resetText, slideEffect = options.slideEffect;
        if (resetText) {
            setInputValue(function () { return ''; });
            return;
        }
        if (slideEffect) {
            setChecked(function (pr) { return !pr; });
        }
        else {
            setChecked(false);
        }
    };
    return (React.createElement(MuiKeyboardContext.Provider, { value: { inputValue: inputValue, keyboardFeature: keyboardFeature } },
        children,
        React.createElement(MuiKeyboard, { setInputValue: setInputValue, textField: textField, slide: slide, direction: direction, checked: checked, numbers: numbers, firstLanguage: firstLanguage, secondLanguage: secondLanguage, secondLangLabel: secondLangLabel, firstLangLabel: firstLangLabel, keyboardWidth: keyboardWidth, buttonSize: buttonSize, labelLangButton: labelLangButton, reverseButton: reverseButton, singlyBack: singlyBack, labelLetterButton: labelLetterButton, betweenButtons: betweenButtons, numbersColumns: numbersColumns, numbersRows: numbersRows, allKeyboardStyle: allKeyboardStyle, timeout: timeout })));
};
export var useMuiKeyboard = function () {
    var context = useContext(MuiKeyboardContext);
    if (!context) {
        throw new Error('useInputValue must be used within an InputValueProvider');
    }
    return context;
};
//# sourceMappingURL=MuiKeyboardProvider.js.map